import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ReopenGroup, CloseGroup } from "../../redux/Batch/BatchSlice";
import { HiChat } from "react-icons/hi";
import { FaUserEdit } from "react-icons/fa";
import styles from "./table.module.css";
import { toast } from "react-toastify";
import AxiosInstance from "../../api/AxiosInstance";
import { RotatingLines } from "react-loader-spinner";
import { Tooltip, Whisper } from "rsuite";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Button,
  styled,
  Modal,
  Box,
  Pagination,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    color: "#D35400",
    fontWeight: "bold",
    fontSize: window.innerWidth > 1600 ? 16 : 14,
    backgroundColor: "#bbbaba",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: window.innerWidth > 1600 ? 14 : 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    // border: 0,
  },
}));

const GroupList = () => {
  let dispatch = useDispatch();
  const [page, setPage] = useState(1);
  let [status, setStatus] = useState([]);
  let [msg, setMsg] = useState("");
  let [itmes, setItems] = useState([]);
  const [defaultData, setDefaultData] = useState([]);
  const [pagination, setPagination] = useState({
    limit: 20,
    page: 1,
    load: false,
    length: 1,
  });
  let [pag, setPag] = useState("");
  let [username, setUsername] = useState("");
  let [userName, setUserName] = useState("");
  let [branchname, setBranchname] = useState("");
  let [branchName, setBranchName] = useState("");
  let [loading, setLoading] = useState(false);
  let { userAdmin } = useSelector(state => state.auth);
  let [valueid, setsValueId] = useState("");
  let [code, setCode] = useState(false);
  let [index, setIndex] = useState(0);
  let [searchTrue, setSearchTrue] = useState(false);
  let [searchTruebranch, setSearchTruebranch] = useState(false);

  //(userAdmin, "userAdmin")
  useEffect(() => {
    async function fetchlist() {
      setLoading(true);
      await AxiosInstance.get(`admin/groupList`, {
        headers: {
          Authorization: `Bearer ${userAdmin.TOKEN}`,
        },
      })
        .then(data => {
          setLoading(false);
          let dataList = data?.data?.result.results;
          let error = data.response?.status;
          setStatus(error);
          setDefaultData(data.data.result);
          setItems(dataList);
          setPagination({
            ...pagination,
            length: data?.data.result.total,
            load: data?.data.result.total > 20 ? false : null,
            page: 1,
            limit: data.data.result.per_page,
          });
        })
        .catch(x => {
          setLoading(null);
          let error = x?.response?.status;
          let message = x.response.data.result.results;
          setStatus(error);
          setMsg(message);
        });
    }
    fetchlist();
  }, []);

  const handleChangePage = async (_, value) => {
    const BranchName = branchName ? `&branch_group=${branchName}` : "";
    const UserName = userName ? `&trainer_hr=${userName}` : "";
    const newPage = value;
    setPagination({ ...pagination, load: true });
    try {
      const { data } = await AxiosInstance.get(
        `admin/groupList?page=${newPage}${BranchName}${UserName}`,
        {
          headers: {
            Authorization: `Bearer ${userAdmin.TOKEN}`,
          },
        }
      );
      setItems(data.result.results);
      setPagination({
        ...pagination,
        length: data.result.total,
        page: value,
        load: false,
      });
    } catch (error) {
      toast.error(error?.response?.status || "something went wrong");
      setPagination({ ...pagination, load: false });
    }
  };

  let HandleClickSearch = () => {
    if (userName.length > 0) {
      setSearchTrue(true);
      setUsername(userName);
    }
  };

  let HandleClearSearch = () => {
    setSearchTrue(false);
    setUserName("");
    setBranchName("");
    setItems(defaultData.results);
    setPagination({
      ...pagination,
      length: defaultData.total,
      load: defaultData.total > 20 ? false : null,
      page: 1,
    });
  };

  const handleSearchFunction = async () => {
    const BranchName = branchName ? `branch_group=${branchName}` : "";
    const UserName = userName ? `&trainer_hr=${userName}` : "";
    setPagination({ ...pagination, load: true });
    try {
      let { data } = await AxiosInstance.get(
        `admin/groupList?${BranchName}${UserName}`,
        {
          headers: {
            Authorization: `Bearer ${userAdmin.TOKEN}`,
          },
        }
      );

      setItems(data.result.results);
      setPagination({
        ...pagination,
        length: data.result.total,
        page: 1,
        load: data.result.total > 20 ? false : null,
      });
    } catch (error) {
      toast.error(error?.response?.status || "something went wrong");
      setPagination({ ...pagination, load: false });
    }
  };

  let HandleClickbranchSearch = () => {
    setSearchTruebranch(true);
    setBranchname(branchName);
  };
  let HandleClearbranchSearch = () => {
    setSearchTruebranch(false);
    setBranchname("");
    setBranchName("");
  };
  const handlePageClick = event => {
    setPage(Number(event.selected + 1));
  };

  const handleGenerateQRCode = async e => {
    //(e);
    let payload = { userId: userAdmin._id, groupCode: e };
    await AxiosInstance.post("admin/branch/groupQrcode", payload, {
      headers: {
        Authorization: `Bearer ${userAdmin.TOKEN}`,
      },
    })
      .then(x => {
        //(x);
        let data = x.data.groupdata;
        let value = {
          Group_Id: data._id,
          Group_Name: data.groupCode,
          User_Id: userAdmin._id,
          User_Name: userAdmin.username,
          Role: userAdmin.role,
          Branch: "",
          Purpose: "",
        };
        //(value);
        setsValueId(JSON.stringify(value));
        setCode(true);
      })
      .catch(x => {});
  };
  //(valueid);
  let handleDownloadQRCode = () => {
    setCode(false);
    //(valueid);
    // const canvas =  document.querySelector("canvas");
    const canvas = document.getElementById(`canvas-${index}`);
    const dataURL = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    //(dataURL);
    const a = document.createElement("a");
    a.href = dataURL;
    a.download = `${valueid}.png`;
    //(valueid);
    document.body.appendChild(a);

    setTimeout(() => {
      a.click();
      document.body.removeChild(a);
    }, 0);
    setsValueId("");
  };
  const handleKeyPress = e => {
    if (e.key === "Enter") {
      if (branchName.trim() !== "") {
        // Trigger search if input is not empty
        HandleClickbranchSearch();
      }
    }
  };
  const handleKeyPressUser = e => {
    if (e.key === "Enter") {
      if (userName.trim() !== "") {
        // Trigger search if input is not empty
        HandleClickSearch();
      }
    }
  };
  const handleBackspace = event => {
    if (event.key === "Backspace" && branchName.length === 1) {
      setSearchTruebranch(false);
      setBranchname("");
      setBranchName("");
    }
  };
  const handleBackspaceUser = event => {
    if (event.key === "Backspace" && userName.length === 1) {
      setSearchTrue(false);
      setUsername("");
      setUserName("");
    }
  };

  // modal for buttons
  const [selectedBatch, setSelectedBatch] = useState(null);

  const [action, setAction] = useState("");
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setSelectedBatch(null);
    setOpen(false);
  };

  const handleSubmitOpenClose = () => {
    if (action === "open") {
      dispatch(ReopenGroup({ _id: selectedBatch._id }));
      toast.success("Group Reopened", {
        position: "top-right",
      });
      setTimeout(() => {
        window.location.assign("/admin-dashboard/admin/groupList");
      }, 1000);
    } else {
      dispatch(CloseGroup({ _id: selectedBatch._id }));

      toast.success("Group Closed", {
        position: "top-right",
      });
      setTimeout(() => {
        window.location.assign("/admin-dashboard/admin/groupList");
      }, 1000);
    }
  };
  // modal dor buttons

  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <Box>
          {selectedBatch ? (
            <aside className={styles.logoutAlertBlock}>
              <h4>
                Are you Sure you want to{" "}
                <b
                  style={{
                    color: action !== "open" ? "crimson" : "green",
                    textTransform: "uppercase",
                  }}
                >
                  "{action}"
                </b>{" "}
                <b style={{ color: "#f16f4d" }}>"{selectedBatch.groupCode}"</b>{" "}
                group?
              </h4>
              <br />
              <div>
                <button type="button" onClick={handleClose}>
                  No
                </button>
                <button type="button" onClick={handleSubmitOpenClose}>
                  Yes
                </button>
              </div>
            </aside>
          ) : (
            "Loading..."
          )}
        </Box>
      </Modal>
      {loading === null ? (
        <h3 style={{ width: "100%", textAlign: "center" }}>
          Something went wrong
        </h3>
      ) : loading ? (
        <div className={styles.loader}>
          <RotatingLines
            strokeColor="#f16f1d"
            strokeWidth="5"
            animationDuration="0.75"
            width="96"
            visible={true}
          />
        </div>
      ) : (
        <Paper
          elevation={12}
          sx={{
            width: "98%",
            overflow: "hidden",
            margin: "0 auto",
            position: "relative",
            marginTop: "20px",
          }}
          className={styles.studentListTable}
        >
          <Grid
            container
            spacing={1}
            className={styles.filterBlock}
            alignItems="center"
          >
            <Grid item md={6}>
              <h4 style={{ color: "#fff", textAlign: "center" }}>Group List</h4>
            </Grid>
            <Grid item md={2} position="relative">
              <span className={styles.searchIcon}>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="#fff"
                  stroke="#F8931F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </span>
              <input
                type="text"
                name="search"
                id="inputName"
                className={styles.studentNameList}
                value={branchName}
                placeholder="Search GroupCode"
                onChange={e => setBranchName(e.target.value)}
                // onKeyPress={handleKeyPress}
                // onKeyDown={handleBackspace}
                style={{ fontWeight: "bold" }}
              />
            </Grid>

            <Grid item md={2} position="relative">
              <span className={styles.searchIcon}>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="#fff"
                  stroke="#F8931F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </span>
              <input
                name="searchuser"
                style={{ fontWeight: "bold" }}
                id="inputNameReq"
                value={userName}
                className={styles.studentNameList}
                type="text"
                placeholder="Search Users"
                onChange={e => setUserName(e.target.value)}
                // onKeyPress={handleKeyPressUser}
                // onKeyDown={handleBackspaceUser}
              />
            </Grid>
            <Grid item md={1}>
              {searchTrue === false ? (
                <Button
                  size="small"
                  type="button"
                  color="warning"
                  sx={{
                    background: "#F87000",
                    color: "#111",
                    fontWeight: "bold",
                    "&:hover": {
                      background: "#F87000",
                      color: "#444",
                    },
                  }}
                  variant="contained"
                  // onClick={HandleClickSearch}
                  onClick={() => {
                    if (branchName === "" && userName === "") {
                      toast.warn("Please Enter Group Code/User Name to search");
                    } else {
                      setSearchTrue(true);
                      handleSearchFunction();
                    }
                  }}
                >
                  Search
                </Button>
              ) : (
                <Button
                  sx={{ fontWeight: "bold" }}
                  size="small"
                  type="button"
                  color="error"
                  variant="contained"
                  onClick={HandleClearSearch}
                >
                  Reset
                </Button>
              )}
            </Grid>
          </Grid>

          <TableContainer
            component={Paper}
            sx={{ height: "75vh", borderRadius: "6px" }}
          >
            <Table
              stickyHeader
              aria-label="sticky table"
              style={{ borderCollapse: "collapse" }}
            >
              <TableHead>
                <TableRow>
                  <StyledTableCell size="small">Id</StyledTableCell>
                  <StyledTableCell align="center" size="small">
                    Groupcode
                  </StyledTableCell>
                  <StyledTableCell align="center" size="small">
                    Branch
                  </StyledTableCell>
                  <StyledTableCell align="center" size="small">
                    Purpose
                  </StyledTableCell>
                  <StyledTableCell align="center" size="small">
                    Admin
                  </StyledTableCell>
                  <StyledTableCell align="center" size="small">
                    Students
                  </StyledTableCell>
                  <StyledTableCell align="center" size="small">
                    View Chat
                  </StyledTableCell>
                  {userAdmin.role[0] === "corporate" ? (
                    <StyledTableCell size="small">Update</StyledTableCell>
                  ) : (
                    ""
                  )}
                  {userAdmin.role[0] === "corporate" ? (
                    <StyledTableCell size="small">Close/Open</StyledTableCell>
                  ) : (
                    ""
                  )}
                </TableRow>
              </TableHead>
              {loading === true ? (
                <div className={styles.loader}>
                  <RotatingLines
                    strokeColor="#f16f1d"
                    strokeWidth="5"
                    animationDuration="0.75"
                    width="96"
                    visible={true}
                  />
                </div>
              ) : (
                <TableBody>
                  {pagination.load ? (
                    <StyledTableRow>
                      <TableCell align="center" colSpan={11}>
                        Loading...
                      </TableCell>
                    </StyledTableRow>
                  ) : itmes?.length < 1 ? (
                    <StyledTableRow>
                      <TableCell align="center" colSpan={11}>
                        No Data Found
                      </TableCell>
                    </StyledTableRow>
                  ) : (
                    <>
                      {itmes?.map((ele, ind) => {
                        return (
                          <StyledTableRow
                            key={ind}
                            className={
                              ele.isOpen === false
                                ? `${styles.GroupClosed}`
                                : `${styles.GroupOpened}`
                            }
                          >
                            <StyledTableCell align="center" size="small">
                              {ele.reqid}
                            </StyledTableCell>
                            <StyledTableCell align="center" size="small">
                              {ele.groupCode}
                            </StyledTableCell>
                            <StyledTableCell align="center" size="small">
                              {ele.branch}
                            </StyledTableCell>
                            <StyledTableCell align="center" size="small">
                              {ele.purpose}
                            </StyledTableCell>
                            {ele?.juniorTrainer?.length > 0 ? (
                              <Whisper
                                followCursor
                                speaker={
                                  <Tooltip>
                                    {ele?.juniorTrainer?.map(x => {
                                      return x.username;
                                    })}
                                  </Tooltip>
                                }
                              >
                                <StyledTableCell size="small">
                                  {ele?.trainer}
                                </StyledTableCell>
                              </Whisper>
                            ) : (
                              <StyledTableCell size="small">
                                {ele?.trainer}
                              </StyledTableCell>
                            )}

                            <StyledTableCell size="small" align="center">
                              {ele.No_ofStudents}
                            </StyledTableCell>
                            <StyledTableCell align="center" size="small">
                              {ele.No_ofStudents == 0 ? (
                                <span
                                  title="No students"
                                  className="color_chat"
                                  style={{
                                    fontSize: "x-large",
                                    cursor: "not-allowed",
                                  }}
                                >
                                  <HiChat />
                                </span>
                              ) : (
                                <Link
                                  to={`${encodeURIComponent(ele.groupCode)}`}
                                >
                                  <span
                                    className="color_chat"
                                    style={{
                                      fontSize: "x-large",
                                    }}
                                  >
                                    <HiChat />
                                  </span>
                                </Link>
                              )}
                            </StyledTableCell>
                            {userAdmin.role.map(x => x === "corporate") ? (
                              <StyledTableCell align="center" size="small">
                                <Link
                                  to={`admin/${encodeURIComponent(
                                    ele.groupCode
                                  )}`}
                                >
                                  <span>
                                    <FaUserEdit></FaUserEdit>
                                  </span>
                                </Link>
                              </StyledTableCell>
                            ) : (
                              ""
                            )}
                            {userAdmin.role[0] === "corporate" ? (
                              <StyledTableCell size="small" align="center">
                                {ele.isOpen === true ? (
                                  <button
                                    className={styles.closeborder}
                                    onClick={() => {
                                      setSelectedBatch(ele);
                                      setAction("close");
                                      handleOpen();
                                    }}
                                  >
                                    Close
                                  </button>
                                ) : (
                                  <button
                                    className={styles.reopen}
                                    onClick={() => {
                                      setSelectedBatch(ele);
                                      setAction("open");
                                      handleOpen();
                                    }}
                                  >
                                    Open
                                  </button>
                                )}
                              </StyledTableCell>
                            ) : (
                              ""
                            )}
                          </StyledTableRow>
                        );
                      })}
                    </>
                  )}
                </TableBody>
              )}
            </Table>
          </TableContainer>

          {pagination.load !== null && (
            <Grid
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "1%",
                marginBottom: "1%",
              }}
            >
              <Pagination
                count={Math.ceil(pagination.length / pagination.limit)}
                color="warning"
                defaultPage={1}
                disabled={pagination.load}
                rowsperpage={pagination.limit}
                siblingCount={1}
                showLastButton={
                  Math.ceil(pagination.length / pagination.limit) > 5
                }
                showFirstButton={
                  Math.ceil(pagination.length / pagination.limit) > 5
                }
                page={pagination.page}
                onChange={handleChangePage}
              />
            </Grid>
          )}
        </Paper>
      )}
    </div>
  );
};

export default GroupList;
